import apprenticeFaqJson from './faq/apprentice.json'
import salonFaqJson from './faq/salon.json'
import shopFaqJson from './faq/shop.json'
import studioFaqJson from './faq/studio.json'
import apprenticePricingJson from './pricing/apprentice.json'
import salonPricingJson from './pricing/salon.json'
import studioPricingJson from './pricing/studio.json'
import cancelPolicyJson from './cancel-policy.json'
import collectionJson from './collection.json'
import companyJson from './company.json'
import membershipJson from './membership.json'
import roomsJson from './rooms.json'
import wardrobeJson from './wardrobe.json'
import type {
  CancelPolicyData,
  CollectionData,
  CompanyData,
  FaqData,
  MembershipData,
  PricingData,
  RoomsData,
  WardrobeData,
} from './types'

export const pricing = {
  salon: salonPricingJson as PricingData,
  studio: studioPricingJson as PricingData,
  apprentice: apprenticePricingJson as PricingData,
}

export const membership = membershipJson as MembershipData
export const rooms = roomsJson as RoomsData
export const collection = collectionJson as CollectionData
export const wardrobe = wardrobeJson as WardrobeData

export const faq = {
  salon: salonFaqJson as FaqData,
  studio: studioFaqJson as FaqData,
  apprentice: apprenticeFaqJson as FaqData,
  shop: shopFaqJson as FaqData,
}

export const cancelPolicy = cancelPolicyJson as CancelPolicyData
export const company = companyJson as CompanyData
